module.exports = __webpack_public_path__ + "static/img/1-6.dec5420.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/6/1-6.png
// module id = 260
// module chunks = 0